/**MAESTROS**/
import FormProductosCRUD from "../views/formularios/productos/FormCRUD";
import FormClientesCRUD from "../views/formularios/clientes/FormCRUD";
import FormPuntoVentaCRUD from "../views/formularios/clientes/FormPuntoVentaCRUD";
import FormRutaCRUD from "../views/formularios/clientes/FormRutaCRUD";
import FormPerfilesCRUD from "../views/formularios/administracion/FormPerfilesCRUD";
import FormUsuariosCRUD from "../views/formularios/administracion/usuarios/FormUsuariosCRUD";
import FormUsuariosPasswordCRUD from "../views/formularios/administracion/usuarios/FormUsuariosPasswordCRUD";
import FormMenuCRUD from "../views/formularios/administracion/FormMenuCRUD";
import FormCRUDPortafolios from "../views/formularios/portafolios/FormCRUD";
import FormCRUDEmpleados from "../views/formularios/empleados/FormCRUD";
import FormCRUDTopes from "../views/formularios/topes/FormCRUD";
import FormCRUDVehiculos from "../views/formularios/vehiculos/FormCRUD";
import FormCRUDCrearActivo from "../views/formularios/crearActivos/FormCRUD";
import FormCRUDReferencias from "../views/formularios/referencias/FormCRUD";
import FormCRUDPrecios from "../views/formularios/precios/FormCRUD";
import TableExcel from "../views/formularios/precios/TableExcel";
import ViewListaSubPortafoliosByPortafolio from "../views/formularios/portafolios/ViewListaSubPortafoliosByPortafolio";
import ViewListaProductosBySubPortafolio from "../views/formularios/portafolios/ViewListaProductosBySubPortafolio";
import FormCRUDPortafoliosComerciales from "../views/formularios/portafolios/FormCRUDPortafoliosComerciales";
import ExpandTablePortafoliosComerciales from "../views/formularios/portafolios/ExpandTablePortafoliosComerciales";
import FormCRUDPortafoliosMateriales from "../views/formularios/portafolios/FormCRUDPortafoliosMateriales";
import ExpandTablePortafoliosMateriales from "../views/formularios/portafolios/ExpandTablePortafoliosMateriales";
import VisibilityColumns from "../components/VisibilidadColumnasAgGrid";
import FormSolicitudesTercerosClientesPtoVentaCRUD from "../views/formularios/clientes/FormCRUDSolicitudesClientes";
import UploadFileModalList from "../components/UploadFileModalList";
import FormUsuariosRolesDetail from "../views/formularios/administracion/usuarios/FormUsuariosRolesDetail";
import ViewDetailErrorsProductsVirtuals from "../views/formularios/productos/ViewDetailErrorsProductsVirtuals";
import TableIntegridad from "src/views/formularios/precios/TableIntegridad";
import FormCRUDEvaluacion from "../views/formularios/evaluacionSolicitudes/FormCRUD";
import TableExcelCliente from "../views/formularios/clientes/TableExcel";
import FormDenegado from "../views/formularios/clientes/FormDenegado";
import TableExcelClienteMercado from "../views/formularios/mercados/TableExcelClienteMercado";
import TableExcelJerarquias from "src/views/formularios/jerarquias/TablaExcel";
import TableExcelPortafolios from "../views/formularios/portafolios/TableExcel";
import TableExcelMercados from "../views/formularios/mercados/TableExcelMercado";
import FormCRUDClienteMercado from "src/views/formularios/mercados/FormCRUDClienteMercado";
import FormCRUDProductoMercado from "src/views/formularios/mercados/FormCRUDProductoMercado";
import TableExcelProductoMercado from "src/views/formularios/mercados/TableExcelProductoMercado";
import TableExcelRezonificacion from "src/views/formularios/rezonificacion/TableExcel";
import FormCRUDPedidoMinimo from "src/views/formularios/pedidoMinimo/FormCRUD";

/**UNOAUNO**/
import TableExcelProductos from "src/views/formularios/unoauno/productos/TableExcel";
import FormCRUDProductos from "src/views/formularios/unoauno/productos/FormCRUD";
import FormCRUDNotificaciones from "src/views/formularios/unoauno/notificaciones/FormCRUD";
import TableErrorExcel from "src/views/formularios/unoauno/general/TableErrorExcel";
import FormCRUDUsuarios from "src/views/formularios/unoauno/usuarios/FormCRUD";
import FormCRUDManuales from "src/views/formularios/unoauno/segmentaciones/FormCRUDManuales";
import FormCRUDSegmentacionesClientes from "src/views/formularios/unoauno/segmentaciones/FormCRUDSegmentacionesClientes";
import FormCRUDAutomaticas from "src/views/formularios/unoauno/segmentaciones/FormCRUDAutomaticas";
import FormListaPreciosShow from "src/views/formularios/unoauno/listaPrecios/FormCRUD";
import FormCRUDMarcas from "src/views/formularios/unoauno/categoriasMarcas/FormCRUDMarcas";
import FormCRUDCategorias from "src/views/formularios/unoauno/categoriasMarcas/FormCRUDCategorias";
import FormCRUDBanners from "src/views/formularios/unoauno/banners/FormCRUDBanners";
import FormCrudPromociones from "src/views/formularios/unoauno/promociones/FormCRUDPromociones";
import FormCRUDPopUps from "src/views/formularios/unoauno/popUps/FormCRUDPopUps";
import FormCRUDGrupos from "src/views/formularios/unoauno/gruposImpulsar/FormCRUDGrupos";
import TableGruposProductos from "src/views/formularios/unoauno/gruposImpulsar/TableGruposProductos";
import FormImagenesProveedores from "src/views/formularios/unoauno/imagenesComponentes/FormImagenesProveedores";
import FormCRUDImagenesComponentes from "src/views/formularios/unoauno/imagenesComponentes/FormCRUDImagenesComponentes";
import ProfileCRUD from "src/views/formularios/unoauno/usuarios/ProfileCRUD";

export const ConstantsFormCrud = {
	/**MAESTROS**/
	modalVisibilityColumns: "MODAL_VISIBILITY_COLUMNS",
	modalCRUDProductos: "CRUD_PRODUCTOS",
	modalCRUDClientes: "CRUD_CLIENTES",
	modalCRUDClientesPuntoVenta: "CRUD_CLIENTES_PUNTO_VENTA_LISTAR",
	modalCRUDClientesPuntoVentaCRUD: "CRUD_CLIENTES_PUNTO_VENTA",
	modalCRUDClientesPuntoVentaRutas: "CRUD_CLIENTES_PUNTO_VENTA_RUTAS",
	modalCRUDClientesRutas: "CRUD_CLIENTES_RUTAS",
	modalCRUDPerfiles: "CRUD_PERFILES",
	modalCRUDUsuarios: "CRUD_USUARIOS",
	modalCRUDUsuariosCreatePassword: "CRUD_USUARIOS_CREATE_PASSWORD",
	modalCRUDUsuariosChangePassword: "CRUD_USUARIOS_CHANGE_PASSWORD",
	modalCRUDMenusAdmin: "CRUD_MENUS_ADMIN",
	modalSIDEUploadFileProductos: "modalSIDEUploadFileProductos",
	modalSIDEUploadFileProductosViewErrorsDetailProductosVirtuales:
		"modalSIDEUploadFileProductosViewErrorsDetailProductosVirtuales",
	modalCRUDPortafolios: "CRUD_PORTAFOLIOS",
	modalCRUDPortafoliosComerciales: "CRUD_PORTAFOLIOS_COMERCIALES",
	modalCRUDPortafoliosMateriales: "modalCRUDPortafoliosMateriales",
	modalViewSubPortafoliosByPortafolio: "MODAL_SUBPORTAFOLIOS_BY_PORTAFOLIO",
	modalViewProductosBySubPortafolio: "MODAL_PRODUCTOS_BY_SUBPORTAFOLIO",
	modalViewExpandPortafoliosComercialesTable: "MODAL_EXPAND_PORTAFOLIOS_COMERCIALES",
	modalViewExpandPortafoliosMaterialesTable: "MODAL_EXPAND_PORTAFOLIOS_MATERIALES",
	modalCRUDEmpleados: "CRUD_EMPLEADOS",
	modalCRUDTopes: "CRUD_TOPES",
	modalCRUDVehiculos: "CRUD_VEHICULOS",
	modalCRUDCrearActivo: "CRUD_CREARACTIVO",
	modalCRUDReferencia: "CRUD_REFERENCIA",
	modalCRUDPrecios: "CRUD_PRECIOS",
	modalTableExcel: "TABLE_EXCEL",
	modalTableIntegridad: "TABLE_INTEGRIDAD",
	modalCRUDSolicitudesClientesTercerosPuntosVenta: "modalCRUDSolicitudesClientesTercerosPuntosVenta",
	modalShowDetailRoles: "modalShowDetailRoles",
	modalCRUDEvaluacion: "CRUD_EVALUACION",
	modalExcelCliente: "TABLE_EXCEL_CLIENTE",
	modalFormDenegado: "FORM_DENEGADO",
	modalExcelClienteMercado: "TABLE_EXCEL_CLIENTE_MERCADO",
	modalExcelJerarquias: "TABLE_EXCEL_JERARQUIAS",
	modalExcelProductos: "TABLE_EXCEL_PRODUCTOS",
	modalTableErrorExcel: "TABLE_ERROR_EXCEL",
	modalExcelPortafolios: "TABLE_EXCEL_PORTAFOLIOS",
	modalExcelMercado: "TABLE_EXCEL_MERCADO",
	modalCRUDClienteMercado: "CRUD_CLIENTE_MERCADO",
	modalCRUDProductoMercado: "CRUD_PRODUCTO_MERCADO",
	modalExcelProductoMercado: "TABLE_EXCEL_PRODUCTO_MERCADO",
	modalExcelRezonificacion: "TABLE_EXCEL_REZONIFICACION",
	modalCRUDPedidoMinimo: "CRUD_PEDIDO_MINIMO",

	/**UNOAUNO**/
	modalCRUDProductosUNOAUNO: "UNOAUNO_CRUD_PRODUCTOS",
	modalCRUDNotificacionesUNOAUNO: "UNOAUNO_CRUD_NOTIFICACIONES",
	modalCRUDSegmentacionesManualesUNOAUNO: "UNOAUNO_CRUD_SEGMENTACIONES_MANUALES",
	modalCRUDSegmentacionesAutomaticasUNOAUNO: "UNOAUNO_CRUD_SEGMENTACIONES_AUTOMATICAS",
	modalCRUDSegmentacionesClientesUNOAUNO: "UNOAUNO_CRUD_SEGMENTACIONES_CLIENTES",
	modalCRUDSegmentacionesErrorUNOAUNO: "UNOAUNO_CRUD_SEGMENTACIONES_ERROR",
	modalCRUDUsuariosUNOAUNO: "UNOAUNO_CRUD_USUARIOS",
	modalCRUDUsuariosProfileUNOAUNO: "UNOAUNO_CRUD_USUARIOS_PROFILE",
	modalShowDetailListaPreciosUNOAUNO: "UNOAUNO_SHOW_LISTA_PRECIOS",
	modalCRUDMarcasUNOAUNO: "UNOAUNO_CRUD_MARCAS",
	modalCRUDCategoriasUNOAUNO: "UNOAUNO_CRUD_CATEGORIAS",
	modalCRUDBannersUNOAUNO: "UNOAUNO_CRUD_BANNERS",
	modalCRUDPromocionesUNOAUNO: "UNOAUNO_CRUD_PROMOCIONES",
	modalCRUDPopUpsUNOAUNO: "UNOAUNO_CRUD_POPUPS",
	modalCRUDGruposUNOAUNO: "UNOAUNO_CRUD_GRUPOS_IMPULSAR",
	modalTableGruposProductosUNOAUNO: "UNOAUNO_TABLE_GRUPOS_PRODUCTOS",
	modalImagenesComponentesUNOAUNO: "UNOAUNO_IMAGENES_PROVEEDORES_COMPONENTES",
	modalCRUDImagenesComponentesUNOAUNO: "UNOAUNO_CRUD_IMAGENES_COMPONENTES",
};

export const routesFormCrudModal = {
	/** MAESTROS**/
	[ConstantsFormCrud.modalCRUDProductos]: FormProductosCRUD,
	[ConstantsFormCrud.modalCRUDClientes]: FormClientesCRUD,
	[ConstantsFormCrud.modalCRUDClientesPuntoVentaCRUD]: FormPuntoVentaCRUD,
	[ConstantsFormCrud.modalCRUDClientesRutas]: FormRutaCRUD,
	[ConstantsFormCrud.modalCRUDPerfiles]: FormPerfilesCRUD,
	[ConstantsFormCrud.modalCRUDUsuarios]: FormUsuariosCRUD,
	[ConstantsFormCrud.modalCRUDPortafolios]: FormCRUDPortafolios,
	[ConstantsFormCrud.modalCRUDPortafoliosComerciales]: FormCRUDPortafoliosComerciales,
	[ConstantsFormCrud.modalCRUDPortafoliosMateriales]: FormCRUDPortafoliosMateriales,
	[ConstantsFormCrud.modalViewExpandPortafoliosComercialesTable]: ExpandTablePortafoliosComerciales,
	[ConstantsFormCrud.modalViewExpandPortafoliosMaterialesTable]: ExpandTablePortafoliosMateriales,
	[ConstantsFormCrud.modalCRUDEmpleados]: FormCRUDEmpleados,
	[ConstantsFormCrud.modalCRUDTopes]: FormCRUDTopes,
	[ConstantsFormCrud.modalCRUDVehiculos]: FormCRUDVehiculos,
	[ConstantsFormCrud.modalCRUDCrearActivo]: FormCRUDCrearActivo,
	[ConstantsFormCrud.modalCRUDReferencia]: FormCRUDReferencias,
	[ConstantsFormCrud.modalCRUDPrecios]: FormCRUDPrecios,
	[ConstantsFormCrud.modalTableExcel]: TableExcel,
	[ConstantsFormCrud.modalTableIntegridad]: TableIntegridad,
	[ConstantsFormCrud.modalCRUDSolicitudesClientesTercerosPuntosVenta]: FormSolicitudesTercerosClientesPtoVentaCRUD,
	[ConstantsFormCrud.modalCRUDEvaluacion]: FormCRUDEvaluacion,
	[ConstantsFormCrud.modalExcelCliente]: TableExcelCliente,
	[ConstantsFormCrud.modalFormDenegado]: FormDenegado,
	[ConstantsFormCrud.modalExcelClienteMercado]: TableExcelClienteMercado,
	[ConstantsFormCrud.modalExcelJerarquias]: TableExcelJerarquias,
	[ConstantsFormCrud.modalExcelProductos]: TableExcelProductos,
	[ConstantsFormCrud.modalTableErrorExcel]: TableErrorExcel,
	[ConstantsFormCrud.modalExcelPortafolios]: TableExcelPortafolios,
	[ConstantsFormCrud.modalExcelMercado]: TableExcelMercados,
	[ConstantsFormCrud.modalCRUDClienteMercado]: FormCRUDClienteMercado,
	[ConstantsFormCrud.modalCRUDProductoMercado]: FormCRUDProductoMercado,
	[ConstantsFormCrud.modalExcelProductoMercado]: TableExcelProductoMercado,
	[ConstantsFormCrud.modalExcelRezonificacion]: TableExcelRezonificacion,
	[ConstantsFormCrud.modalCRUDPedidoMinimo]: FormCRUDPedidoMinimo,

	/**UNOAUNO**/
	[ConstantsFormCrud.modalCRUDProductosUNOAUNO]: FormCRUDProductos,
	[ConstantsFormCrud.modalCRUDNotificacionesUNOAUNO]: FormCRUDNotificaciones,
	[ConstantsFormCrud.modalCRUDSegmentacionesManualesUNOAUNO]: FormCRUDManuales,
	[ConstantsFormCrud.modalCRUDSegmentacionesAutomaticasUNOAUNO]: FormCRUDAutomaticas,
	[ConstantsFormCrud.modalCRUDSegmentacionesClientesUNOAUNO]: FormCRUDSegmentacionesClientes,
	[ConstantsFormCrud.modalCRUDUsuariosUNOAUNO]: FormCRUDUsuarios,
	[ConstantsFormCrud.modalCRUDUsuariosProfileUNOAUNO]: ProfileCRUD,
	[ConstantsFormCrud.modalShowDetailListaPreciosUNOAUNO]: FormListaPreciosShow,
	[ConstantsFormCrud.modalCRUDMarcasUNOAUNO]: FormCRUDMarcas,
	[ConstantsFormCrud.modalCRUDCategoriasUNOAUNO]: FormCRUDCategorias,
	[ConstantsFormCrud.modalCRUDBannersUNOAUNO]: FormCRUDBanners,
	[ConstantsFormCrud.modalCRUDPromocionesUNOAUNO]: FormCrudPromociones,
	[ConstantsFormCrud.modalCRUDPopUpsUNOAUNO]: FormCRUDPopUps,
	[ConstantsFormCrud.modalCRUDGruposUNOAUNO]: FormCRUDGrupos,
	[ConstantsFormCrud.modalTableGruposProductosUNOAUNO]: TableGruposProductos,
	[ConstantsFormCrud.modalImagenesComponentesUNOAUNO]: FormImagenesProveedores,
	[ConstantsFormCrud.modalCRUDImagenesComponentesUNOAUNO]: FormCRUDImagenesComponentes,
};

export const routesFormSideModal = {
	[ConstantsFormCrud.modalVisibilityColumns]: VisibilityColumns,
	[ConstantsFormCrud.modalCRUDUsuariosChangePassword]: FormUsuariosPasswordCRUD,
	[ConstantsFormCrud.modalCRUDMenusAdmin]: FormMenuCRUD,
	[ConstantsFormCrud.modalViewSubPortafoliosByPortafolio]: ViewListaSubPortafoliosByPortafolio,
	[ConstantsFormCrud.modalViewProductosBySubPortafolio]: ViewListaProductosBySubPortafolio,
	[ConstantsFormCrud.modalSIDEUploadFileProductos]: UploadFileModalList,
	[ConstantsFormCrud.modalSIDEUploadFileProductosViewErrorsDetailProductosVirtuales]: ViewDetailErrorsProductsVirtuals,
	[ConstantsFormCrud.modalShowDetailRoles]: FormUsuariosRolesDetail,
};
